import Vue from 'vue';
import toast from './toast.vue';
const ToastConstructor = Vue.extend(toast);//基础构造器extend创建一个子类，参数是一个包含组件选项的对象。
let instance;
const Toast = function(options){
    instance = new ToastConstructor({
        data:options
    }).$mount();
    document.body.appendChild(instance.$el);
};
['success','error'].forEach((item)=>{
    Toast[item]=options=>{
        options.type=item;
        return Toast(options)
    }
})
export default Toast;


// WEBPACK FOOTER //
// ./src/components/toast/toast.js